import { action } from "typesafe-actions";
import {
  IActivityComment,
  IAuditLog,
  IGeneralHistory,
  IMail,
  IPolicies,
  IRecordCount,
} from "./common.types";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "..";
import { AnyAction } from "redux";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { api } from "../../api/api";
import { LoadState } from "../../constants/enums";
import { IComment } from "../comments";
import { uploadFile } from "../../helpers/uploadFile";
import { uploadMultipleFile } from "../../components/FileUpload/utils";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";

export const FETCH_POLICIES_PROGRESS = "FETCH_POLICIES_PROGRESS";
export const FETCH_POLICIES_SUCCESS = "FETCH_POLICIES_SUCCESS";
export const FETCH_POLCIES_FAILED = "FETCH_POLCIES_FAILED";

export const fetchPoliciesProgress = () => action(FETCH_POLICIES_PROGRESS);
export const fetchPoliciesSuccess = (policies: IPolicies[]) =>
  action(FETCH_POLICIES_SUCCESS, { policies });
export const fetchPoliciesFailed = () => action(FETCH_POLCIES_FAILED);
export const fetchPolicies =
  (): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    const policies = getState().common.policies;
    if (policies.loadState !== LoadState.Loaded) {
      try {
        dispatch(fetchPoliciesProgress());
        const res = await api.get(`/policy/get-policies`);
        const data: IPolicies[] = res.data.data;

        dispatch(fetchPoliciesSuccess(data));
      } catch (err: any) {
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          }),
        );
        dispatch(fetchPoliciesFailed());
      }
    }
  };

export const fetchInitialRefData =
  (): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    dispatch(fetchPolicies());
  };

export const sendMessageToUserPhone =
  (
    data: {
      mobileNumber: string;
      message: string;
    },
    onCallback: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      await api.post(`/general/send-sms`, {
        recipients: [
          {
            to: "+1" + data.mobileNumber,
            name: data.message,
          },
        ],
      });
      dispatch(
        showMessage({
          type: "success",
          message: "Message send successfully!",
          displayAs: "snackbar",
        }),
      );

      onCallback(true);
    } catch (err: any) {
      onCallback(true);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const sendMessageToWhatsapp =
  (
    data: {
      mobileNumber: string;
      message: string;
    },
    onCallback: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      await api.post(`/general/send-whatsapp`, {
        recipients: [
          {
            to: "+1" + data.mobileNumber,
            name: data.message,
          },
        ],
      });
      dispatch(
        showMessage({
          type: "success",
          message: "Message send successfully!",
          displayAs: "snackbar",
        }),
      );

      onCallback(true);
    } catch (err: any) {
      onCallback(true);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const sendVoiceCalling =
  (
    data: {
      mobileNumber: string;
    },
    onCallback: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      await api.post(`/general/voice-calling`, {
        recipients: [
          {
            to: "+1" + data.mobileNumber,
          },
        ],
      });
      dispatch(
        showMessage({
          type: "success",
          message: "Voice calling is send successfully!",
          displayAs: "snackbar",
        }),
      );

      onCallback(true);
    } catch (err: any) {
      onCallback(true);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const getStockInfoAsync =
  (
    productUuid: string,
    billingCompanyUuid: string,
    onCallback: (isSuccess: boolean, balance: string) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      const res = await api.get(
        `/product/get-stock-info?product_uuid=${productUuid}&billing_company_uuid=${billingCompanyUuid}`,
      );

      const data: string = res.data ? res.data.data.balance : "0";

      onCallback(true, data);
    } catch (err: any) {
      onCallback(false, "0");
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const sendEmail =
  (
    data: IMail,
    onCallback: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      await api.post(`/general/send-email`, {
        ...data,
      });
      dispatch(
        showMessage({
          type: "success",
          message: "Email is send successfully!",
          displayAs: "snackbar",
        }),
      );

      onCallback(true);
    } catch (err: any) {
      onCallback(true);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const FETCH_GENERAL_HISTORY_LIST_PROGRESS =
  "FETCH_GENERAL_HISTORY_LIST_PROGRESS";
export const FETCH_GENERAL_HISTORY_LIST_SUCCESS =
  "FETCH_GENERAL_HISTORY_LIST_SUCCESS";
export const FETCH_GENERAL_HISTORY_LIST_FAILED =
  "FETCH_GENERAL_HISTORY_LIST_FAILED";

export const fetchGeneraHistoryListProgress = () =>
  action(FETCH_GENERAL_HISTORY_LIST_PROGRESS);
export const fetchGeneraHistoryListSuccess = (data: IGeneralHistory[]) =>
  action(FETCH_GENERAL_HISTORY_LIST_SUCCESS, { data });
export const fetchGeneraHistoryListFailed = () =>
  action(FETCH_GENERAL_HISTORY_LIST_FAILED);

export const fetchGeneraHistoryListAsync =
  (
    customerPolicyId: number,
    tableName: string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchGeneraHistoryListProgress());
      const res = await api.get(
        `/general/get-log-data?table_name=${tableName}&customer_policy_id=${customerPolicyId}`,
      );

      const data: IGeneralHistory[] = res.data.data;
      if (data) {
        dispatch(fetchGeneraHistoryListSuccess(data));
      } else {
        dispatch(fetchGeneraHistoryListSuccess([]));
      }
    } catch (err: any) {
      dispatch(fetchGeneraHistoryListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const CLEAR_GENERAL_HISTORY_STATE = "CLEAR_GENERAL_HISTORY_STATE";

export const clearGeneraHistoryState = () =>
  action(CLEAR_GENERAL_HISTORY_STATE);

export const FETCH_RECORD_COUNTS_PROGRESS = "FETCH_RECORD_COUNTS_PROGRESS";
export const FETCH_RECORD_COUNTS_SUCCESS = "FETCH_RECORD_COUNTS_SUCCESS";
export const FETCH_RECORD_COUNTS_FAILED = "FETCH_RECORD_COUNTS_FAILED";

export const fetchRecordsCountsProgress = () =>
  action(FETCH_RECORD_COUNTS_PROGRESS);
export const fetchRecordsCountsSuccess = (data: IRecordCount[]) =>
  action(FETCH_RECORD_COUNTS_SUCCESS, { data });
export const fetchRecordsCountsFailed = () =>
  action(FETCH_RECORD_COUNTS_FAILED);

export const fetchRecordCountsAsync =
  (
    tableName: string,
    fromDate: string,
    toDate: string,
    billing_company_uuid: string,
    type?: "EXPENSE" | "ADVANCE",
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchRecordsCountsProgress());
      let query = "";
      if (billing_company_uuid) {
        query = `&billing_company_uuid=${billing_company_uuid}`;
      }
      if (type && type === "EXPENSE") {
        query += `&expense_type=JOB&expense_type=EXPENSE`;
      }
      if (type && type === "ADVANCE") {
        query += `&expense_type=ADVANCE`;
      }
      const res = await api.get(
        `/general/get-record-counts?table_name=${tableName}&from_date=${fromDate}&to_date=${toDate}` +
          query,
      );

      const data: IRecordCount[] = res.data.data;

      dispatch(fetchRecordsCountsSuccess(data || []));
    } catch (err: any) {
      dispatch(fetchRecordsCountsFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const fetchHistoryByTableColumnAsync =
  (
    module_code: string | number,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchGeneraHistoryListProgress());
      const res = await api.get(
        `/history/get-history?module_uuid=${module_code}`,
      );

      const data: IGeneralHistory[] = res.data.data;
      if (data) {
        dispatch(fetchGeneraHistoryListSuccess(data));
      } else {
        dispatch(fetchGeneraHistoryListSuccess([]));
      }
    } catch (err: any) {
      dispatch(fetchGeneraHistoryListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const addActivityCommentAsync =
  (
    data: IActivityComment,
    files: File[],
    onCallback: (isSuccess: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      const {
        create_ts,
        insert_ts,
        modified_by_uuid,
        created_by_uuid,

        status,
        ...rest
      } = data;
      dispatch(saveLoaderProgress());

      const asPayload = {
        title: data.comment_remark,
      };

      const { paths } = await uploadMultipleFile(
        files.map((file) => ({ key: "", path: "", file, type: "LOCAL" })),
        "COMMENT",
        asPayload,
      );

      await api.post("/comment/upsert-comment", {
        ...rest,
        attachment: paths,
      });

      dispatch(saveLoaderCompleted());
      dispatch(
        showMessage({
          type: "success",
          message: "Document saved successfully!",
          displayAs: "snackbar",
        }),
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response?.data?.message || "Failed to upload document",
          displayAs: "snackbar",
        }),
      );
    }
  };

export const FETCH_ACTIVITY_COMMENT_PROGRESS =
  "FETCH_ACTIVITY_COMMENT_PROGRESS";
export const FETCH_ACTIVITY_COMMENT_SUCCESS = "FETCH_ACTIVITY_COMMENT_SUCCESS";
export const FETCH_ACTIVITY_COMMENT_FAILED = "FETCH_ACTIVITY_COMMENT_FAILED";

export const fetchActivityCommentProgress = () =>
  action(FETCH_ACTIVITY_COMMENT_PROGRESS);
export const fetchActivityCommentSuccess = (data: IActivityComment[]) =>
  action(FETCH_ACTIVITY_COMMENT_SUCCESS, { data });
export const fetchActivityCommentFailed = () =>
  action(FETCH_ACTIVITY_COMMENT_FAILED);

export const fetchActivityCommentListAsync =
  (
    module_code: string | number,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchActivityCommentProgress());
      const res = await api.get(
        `/comment/get-comment?record_uuid=${module_code}`,
      );

      const data: IActivityComment[] = res.data.data;
      if (data) {
        dispatch(fetchActivityCommentSuccess(data));
      } else {
        dispatch(fetchActivityCommentSuccess([]));
      }
    } catch (err: any) {
      dispatch(fetchActivityCommentFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const CLEAR_RECORD_COUNTS = "CLEAR_RECORD_COUNTS";
export const clearRecordCounts = () => action(CLEAR_RECORD_COUNTS);

// Audit Logs Actions
export const FETCH_AUDIT_LOGS_PROGRESS = "FETCH_AUDIT_LOGS_PROGRESS";
export const FETCH_AUDIT_LOGS_SUCCESS = "FETCH_AUDIT_LOGS_SUCCESS";
export const FETCH_AUDIT_LOGS_FAILED = "FETCH_AUDIT_LOGS_FAILED";

export const fetchAuditLogsProgress = () => action(FETCH_AUDIT_LOGS_PROGRESS);
export const fetchAuditLogsSuccess = (data: IAuditLog[]) =>
  action(FETCH_AUDIT_LOGS_SUCCESS, { data });
export const fetchAuditLogsFailed = () => action(FETCH_AUDIT_LOGS_FAILED);

export const fetchAuditLogsAsync =
  (entityUuid: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      console.log(
        "fetchAuditLogsAsync: Starting API call with entityUuid:",
        entityUuid,
      );
      dispatch(fetchAuditLogsProgress());
      const apiUrl = `/general/get-audit-logs?entity_uuid=${entityUuid}`;
      console.log("fetchAuditLogsAsync: Making API call to:", apiUrl);
      const res = await api.get(apiUrl);

      console.log("fetchAuditLogsAsync: API response:", res.data);
      const data: IAuditLog[] = res.data.data || res.data;
      if (data) {
        console.log("fetchAuditLogsAsync: Success - received data:", data);
        dispatch(fetchAuditLogsSuccess(data));
      } else {
        console.log("fetchAuditLogsAsync: Success - no data received");
        dispatch(fetchAuditLogsSuccess([]));
      }
    } catch (err: any) {
      console.error("fetchAuditLogsAsync: Error:", err);
      dispatch(fetchAuditLogsFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response?.data?.message || "Failed to fetch audit logs",
          displayAs: "snackbar",
        }),
      );
    }
  };

export const CLEAR_AUDIT_LOGS = "CLEAR_AUDIT_LOGS";
export const clearAuditLogs = () => action(CLEAR_AUDIT_LOGS);
